/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1CreateRecruitmentInput } from '../../entities/v1/CreateRecruitmentInput'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1CreateRecruitmentInputSchema = z.object({
  drivee_city_id: z.number().int(),
  phone: z.number().int(),
}) as unknown as ToZod<V1CreateRecruitmentInput>